import { MARK_COOKIE_BANNER_SEEN } from '../../actionTypes';

export const markCookieBannerSeen = () => ({ type: MARK_COOKIE_BANNER_SEEN });
